import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "modal",
  tabindex: "-1",
  id: "pryal_veiculo_cadastro"
}
const _hoisted_2 = { class: "\n        modal-dialog\n        modal-dialog-centered\n        modal-dialog-scrollable\n        modal-fullscreen-sm-down\n      " }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title d-flex flex-column align-items-start" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-floating mb-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { selected: "" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("option", { value: "AstonMartin" }, "Aston Martin", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "Audi" }, "Audi", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: "Bentley" }, "Bentley", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "BMW" }, "BMW", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "CaoaChery" }, "Caoa Chery", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", { value: "Chevrolet" }, "Chevrolet", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("option", { value: "Chrysler" }, "Chrysler", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("option", { value: "Citroen" }, "Citroen", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "Dodge" }, "Dodge", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "Ferrari" }, "Ferrari", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "Fiat" }, "Fiat", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("option", { value: "Ford" }, "Ford", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("option", { value: "Honda" }, "Honda", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "Husqvarna" }, "Husqvarna", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "Hyundai" }, "Hyundai", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "JAC" }, "JAC", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("option", { value: "Jaguar" }, "Jaguar", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("option", { value: "Jeep" }, "Jeep", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("option", { value: "Kia" }, "Kia", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("option", { value: "Lamborguini" }, "Lamborguini", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("option", { value: "LandRover" }, "Land Rover", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("option", { value: "Lexus" }, "Lexus", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("option", { value: "Lifan" }, "Lifan", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("option", { value: "Maserati" }, "Maserati", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("option", { value: "McLaren" }, "McLaren", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("option", { value: "Mercedes" }, "Mercedes", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("option", { value: "Mini" }, "Mini", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("option", { value: "Mistubishi" }, "Mistubishi", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("option", { value: "Nissan" }, "Nissan", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "Peugeot" }, "Peugeot", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "Porsche" }, "Porsche", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("option", { value: "Renault" }, "Renault", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("option", { value: "RollsRoyce" }, "Rolls Royce", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("option", { value: "RoyalEnfield" }, "Royal Enfield", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("option", { value: "Smart" }, "Smart", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("option", { value: "Subaru" }, "Subaru", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("option", { value: "Susuki" }, "Susuki", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("option", { value: "Toyota" }, "Toyota", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("option", { value: "Triumph" }, "Triumph", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("option", { value: "Troller" }, "Troller", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("option", { value: "Volkswagen" }, "Volkswagen", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("option", { value: "Volvo" }, "Volvo", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("option", { value: "Yamaha" }, "Yamaha", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { for: "formMarca" }, "Marca", -1)
const _hoisted_56 = { class: "invalid-feedback" }
const _hoisted_57 = { class: "form-floating mb-3" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", { for: "formModelo" }, "Modelo", -1)
const _hoisted_59 = { class: "invalid-feedback" }
const _hoisted_60 = { class: "input-group mb-3" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "KM", -1)
const _hoisted_62 = { class: "invalid-feedback" }
const _hoisted_63 = { class: "form-floating mb-3" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "formAnofabricacao" }, "Ano Fabricação", -1)
const _hoisted_65 = { class: "invalid-feedback" }
const _hoisted_66 = { class: "form-floating mb-3" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", { for: "formAnomodelo" }, "Ano Modelo", -1)
const _hoisted_68 = { class: "invalid-feedback" }
const _hoisted_69 = { class: "form-floating mb-3" }
const _hoisted_70 = /*#__PURE__*/_createVNode("label", { for: "formPlaca" }, "Placa", -1)
const _hoisted_71 = { class: "invalid-feedback" }
const _hoisted_72 = { class: "form-floating mb-3" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", { for: "formRenavam" }, "Renavam", -1)
const _hoisted_74 = { class: "invalid-feedback" }
const _hoisted_75 = { class: "form-floating mb-3" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", { for: "formChassi" }, "Chassi", -1)
const _hoisted_77 = { class: "invalid-feedback" }
const _hoisted_78 = { class: "modal-footer" }
const _hoisted_79 = {
  type: "button",
  ref: "closeModal",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_Form = _resolveComponent("Form")
  const _directive_mask = _resolveDirective("mask")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h5", _hoisted_5, [
            (_ctx.isCadastroNovo)
              ? (_openBlock(), _createBlock("span", _hoisted_6, " Cadastro de novo veículo "))
              : (_openBlock(), _createBlock("span", _hoisted_7, "Atualizar cadastro de " + _toDisplayString(_ctx.veiculo.modelo), 1)),
            _createVNode("button", {
              class: "btn btn-sm btn-link p-0",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
            }, " Excluir ")
          ]),
          _hoisted_8
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Form, {
            name: "formVeiculo",
            id: "formVeiculo",
            class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
            ref: "form",
            onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCadastroNovo === true ? _ctx.cadastrar() : _ctx.atualizar())),
            "validation-schema": _ctx.validacoes
          }, {
            default: _withCtx(({ errors }) => [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.marca,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cadastro.marca = $event)),
                  as: "select",
                  class: [{ 'is-invalid': errors.formMarca }, "form-select"],
                  name: "formMarca",
                  "aria-label": "Floating label select example",
                  placeholder: "Marca"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _hoisted_35,
                    _hoisted_36,
                    _hoisted_37,
                    _hoisted_38,
                    _hoisted_39,
                    _hoisted_40,
                    _hoisted_41,
                    _hoisted_42,
                    _hoisted_43,
                    _hoisted_44,
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47,
                    _hoisted_48,
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51,
                    _hoisted_52,
                    _hoisted_53,
                    _hoisted_54
                  ]),
                  _: 2
                }, 1032, ["modelValue", "class"]),
                _hoisted_55,
                _createVNode("div", _hoisted_56, _toDisplayString(errors.formMarca), 1)
              ]),
              _createVNode("div", _hoisted_57, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.modelo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cadastro.modelo = $event)),
                  type: "text",
                  class: [{ 'is-invalid': errors.formModelo }, "form-control"],
                  name: "formModelo",
                  placeholder: "Modelo"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_58,
                _createVNode("div", _hoisted_59, _toDisplayString(errors.formModelo), 1)
              ]),
              _createVNode("div", _hoisted_60, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.quilometragem,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cadastro.quilometragem = $event)),
                  type: "number",
                  class: [{ 'is-invalid': errors.formQuilimetragem }, "form-control"],
                  placeholder: "Quilometragem",
                  "aria-label": "Quilometragem",
                  name: "formQuilimetragem"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_61,
                _createVNode("div", _hoisted_62, _toDisplayString(errors.formQuilimetragem), 1)
              ]),
              _createVNode("div", _hoisted_63, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.anoFabricacao,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.cadastro.anoFabricacao = $event)),
                  type: "text",
                  class: [{ 'is-invalid': errors.formAnofabricacao }, "form-control"],
                  name: "formAnofabricacao",
                  placeholder: "Ano Fabricação"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_64,
                _createVNode("div", _hoisted_65, _toDisplayString(errors.formAnofabricacao), 1)
              ]),
              _createVNode("div", _hoisted_66, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.anoModelo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.cadastro.anoModelo = $event)),
                  type: "text",
                  class: [{ 'is-invalid': errors.formAnomodelo }, "form-control"],
                  name: "formAnomodelo",
                  placeholder: "Ano Modelo"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_67,
                _createVNode("div", _hoisted_68, _toDisplayString(errors.formAnomodelo), 1)
              ]),
              _createVNode("div", _hoisted_69, [
                _withDirectives(_createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.placa,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.cadastro.placa = $event)),
                  type: "text",
                  class: [{ 'is-invalid': errors.formPlaca }, "form-control text-uppercase"],
                  name: "formPlaca",
                  placeholder: "Placa"
                }, null, 8, ["modelValue", "class"]), [
                  [_directive_mask, 'AAA-#X##']
                ]),
                _hoisted_70,
                _createVNode("div", _hoisted_71, _toDisplayString(errors.formPlaca), 1)
              ]),
              _createVNode("div", _hoisted_72, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.renavam,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.cadastro.renavam = $event)),
                  type: "number",
                  class: [{ 'is-invalid': errors.formRenavam }, "form-control"],
                  name: "formRenavam",
                  placeholder: "Renavam"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_73,
                _createVNode("div", _hoisted_74, _toDisplayString(errors.formRenavam), 1)
              ]),
              _createVNode("div", _hoisted_75, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.cadastro.chassi,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.cadastro.chassi = $event)),
                  type: "text",
                  class: [{ 'is-invalid': errors.formChassi }, "form-control text-uppercase"],
                  name: "formChassi",
                  placeholder: "Chassi"
                }, null, 8, ["modelValue", "class"]),
                _hoisted_76,
                _createVNode("div", _hoisted_77, _toDisplayString(errors.formChassi), 1)
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _createVNode("div", _hoisted_78, [
          _createVNode("button", _hoisted_79, " Fechar ", 512),
          _createVNode("input", {
            type: "submit",
            class: "btn btn-primary",
            form: "formVeiculo",
            value: _ctx.isCadastroNovo === true ? 'Cadastrar' : 'Atualizar'
          }, null, 8, ["value"])
        ])
      ])
    ])
  ], 512))
}